import { client } from '../client';
import { getStaffScopedApiPrefix } from '@brands/Utils/staffScopedApiPrefix';
import { UserRoleName } from '../identity/types/UserProfile';

export const markLastReadMessage = async (
  conversationSid: string,
  messageSid: string,
  userRole?: string,
): Promise<void> => {
  const prefix = getStaffScopedApiPrefix(userRole);
  if (prefix) {
    const { data } = await client.patch(`${prefix}/conversations/${conversationSid}/messages/${messageSid}/read`);
    return data;
  }
  try {
    const { data } = await client.patch(`/conversations/${conversationSid}/messages/${messageSid}/read`);
    return data;
  } catch (error: any) {
    if ((!userRole || userRole === UserRoleName.Collector) && error?.response?.status === 403) {
      const collectorPrefix = getStaffScopedApiPrefix(UserRoleName.Collector);
      const { data } = await client.patch(
        `${collectorPrefix}/conversations/${conversationSid}/messages/${messageSid}/read`,
      );
      return data;
    }
    throw error;
  }
};
